exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hapyak-app, .hapyak-app * {\n    box-sizing: border-box;\n}", ""]);

